import { useState } from "react";
import { Branch } from "../../models/response/branch";
import { IconCheckSuccess } from "../icons/icon-group";
import { ButtonCustom } from "./button-custom";
import DropdownSelectOne from "./dropdown-select-one";
import { ModalCustom } from "./modal-custom";

interface ConfirmModalProps {
    title: string,
    description: string,
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    onClose: () => void;
    onConfirm: () => void;
}

const ConfirmModal = ({ title, description, isOpen, setIsOpen, onClose, onConfirm }: ConfirmModalProps) => {
    const [selectedBranchId, setSelectedBranchId] = useState<string>('');
    const footerModal = () => {
        return (
            <>
                <ButtonCustom
                    type="button"
                    text="Hủy bỏ"
                    onClick={onClose}
                    className="text-gray-500 bg-gray-100 hover:bg-gray-400 hover:text-white"
                />
                <ButtonCustom
                    type="button"
                    text="Đồng ý"
                    onClick={onConfirm}
                />
            </>
        )
    }
    const bodyModal = () => {
        return (
            <div className="flex flex-col items-center justify-center">
                {description}
            </div>
        )
    }
    return (
        <ModalCustom
            modalSize='lg'
            isOpen={isOpen}
            setIsOpen={() => setIsOpen(false)}
            titleModal={title}
            footerModal={footerModal()}
            bodyModal={bodyModal()}
        />
    )
}

export default ConfirmModal